var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mt-0 mb-2",attrs:{"hide-details":""},on:{"change":_vm.changeValue},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }